import React, { memo, forwardRef, useMemo, useImperativeHandle, useCallback, useState } from "react";
import PropTypes from "prop-types";

import classNames from "common/class-names";
import AppLoadingIndicator from "components/app-loading-indicator";

const AppScreenLoading = (props, ref) => {
	const [visible, setVisible] = useState(false);
	const [animation, setAnimation] = useState(false);
	//prettier-ignore
	const className = useMemo(() => classNames({
		"app-screen-loading": true,
        "app-screen-loading--active": animation
	}), [animation]);

	const onHandleShow = useCallback(() => {
		setVisible(true);
		setAnimation(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setAnimation(false);

		setTimeout(() => {
			setVisible(false);
		}, 500);
	}, []);

	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	if (!visible) return null;

	return (
		<div className={className}>
			<div className="screen-loading">
				<AppLoadingIndicator />
			</div>
		</div>
	);
};

export default memo(forwardRef(AppScreenLoading));

AppScreenLoading.propTypes = {
	ref: PropTypes.object,
};
